<template>
    <section class="bg-[#f7f4ef] py-16 text-[#171717] md:py-24">
        <div class="mx-auto max-w-7xl px-5 lg:px-12">
            <div class="flex items-end justify-between gap-6">
                <div>
                    <div class="text-sm uppercase tracking-[0.35em] text-[#b49d7c]">
                        {{ t.benefits.badge }}
                    </div>

                    <h2 class="mt-4 font-serif text-3xl uppercase leading-none md:text-5xl">
                        {{ t.benefits.title }}
                    </h2>
                </div>

                <div class="hidden text-sm text-black/40 lg:block">
                    Batumi Center House
                </div>
            </div>

            <div class="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
                <div
                    v-for="item in t.benefits.items"
                    :key="item.title"
                    class="group relative min-h-72 overflow-hidden rounded-[32px]
                    border border-[#c8b79c]/12
                    bg-[radial-gradient(circle_at_top,rgba(200,183,156,0.12),transparent_38%),linear-gradient(180deg,#111111_0%,#090909_100%)]
                    p-6 text-white
                    shadow-[0_20px_80px_rgba(0,0,0,0.28)]
                    transition duration-500
                    hover:-translate-y-1.5
                    hover:border-[#c8b79c]/28
                    hover:shadow-[0_35px_120px_rgba(0,0,0,0.42)]"
                >
                    <div
                        class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#e2d0b2]/70 to-transparent"></div>

                    <div
                        class="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#c8b79c]/12 blur-3xl transition duration-500 group-hover:bg-[#c8b79c]/18"></div>

                    <div class="absolute -bottom-10 -left-10 h-32 w-32 rounded-full bg-white/[0.03] blur-3xl"></div>

                    <div
                        class="absolute inset-0 opacity-0 transition duration-500 group-hover:opacity-100 bg-[linear-gradient(135deg,rgba(255,255,255,0.04),transparent_35%)]"></div>

                    <div class="relative z-10 flex h-full flex-col">
                        <div
                            class="flex h-14 w-14 items-center justify-center rounded-2xl
                            border border-[#d8c5a7]/20
                            bg-[linear-gradient(180deg,rgba(255,255,255,0.08),rgba(255,255,255,0.02))]
                            text-[#d8c5a7]
                            shadow-[0_10px_30px_rgba(200,183,156,0.12)]"
                        >
                            <component
                                :is="icons[item.icon]"
                                class="h-6 w-6"
                            />
                        </div>

                        <h3 class="mt-8 font-serif text-2xl uppercase leading-tight text-white">
                            {{ item.title }}
                        </h3>

                        <p class="mt-4 text-sm leading-relaxed text-white/58">
                            {{ item.text }}
                        </p>

                        <div class="mt-auto pt-7">
                            <div
                                class="flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-[#d4c0a0]/85">
                                <span class="h-px w-8 bg-[#c8b79c]/45"></span>
                                Batumi
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {useHomeStore} from '@js/store/homeStore.js';

import IconCity from '@js/components/Icons/IconCity.vue';
import IconWalk from '@js/components/Icons/IconWalk.vue';
import IconBusiness from '@js/components/Icons/IconBusiness.vue';
import IconGrowth from '@js/components/Icons/IconGrowth.vue';

export default {
    name: 'BenefitsSection',

    data() {
        return {
            icons: {
                city: IconCity,
                walk: IconWalk,
                business: IconBusiness,
                growth: IconGrowth,
            },
        };
    },

    computed: {
        homeStore() {
            return useHomeStore();
        },

        locale() {
            return this.homeStore.getLocale(this.$page);
        },

        t() {
            return this.homeStore.getTranslations(this.locale);
        },
    },
};
</script>
